import ApiService from "@/modules/api/api.service";

import ObjectBuilderInterface from "../api/object-builder.interface";
import { ImageType } from "./imageType";
import Item from "./item.model";

export default class FileProcessingRepository {
  constructor(
    private api: ApiService,
    private plushieBuilder: ObjectBuilderInterface<Item>
  ) {}

  public async uploadFile(
    file: File,
    imageType: Exclude<ImageType, ImageType.QaVideo | ImageType.QaVideoThumb>,
    product?: string,
    onUploadProgress?: (progressEvent: ProgressEvent) => void
  ): Promise<Item> {
    const formData = new FormData();
    formData.append("file", file, file.name);

    formData.append("imageType", imageType.toString());

    if (product) {
      formData.append("product", product);
    }

    const result = await this.api.post(
      "file_upload_jobs",
      formData,
      onUploadProgress
    );

    return this.plushieBuilder.buildFromJSON(result.data["item"]);
  }
}
